import { atom } from "recoil";

export const gamesSectionModalStore = atom({
	key: "gamesSectionModalStore",
	default: {
		show: false,
		mode: "add", // 'add' | 'edit'
		loaded: true,
		formData: {
			id: 0,
			name: "",
			page: [],
			priority_by_page: {},
			icon: "",
			status: { value: "active", label: "Active" },
			date: new Date(),
		},
	},
});
